module.exports = __webpack_public_path__ + "static/media/apparel1.736313e6.jpg";